export default __webpack_public_path__ + "static/media/grid.014.9be9cf31.jpeg";